import { useMutation, useQueryClient } from "@tanstack/react-query";
import authAPI from "../../api/auth/api";
import { getQueryKey as getCurrentUserQueryKey } from "./use-get-current-user";

export function useLogin() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: authAPI.loginUser,
    onSuccess: (data) => {
      // Invalidate and refetch current user
      queryClient.invalidateQueries({ queryKey: getCurrentUserQueryKey() });
    },
    onError: (error) => {},
  });
}
